const types = {
  GET_PAGE_ANALYTICS_START: 'GET_PAGE_ANALYTICS_START',
  GET_PAGE_ANALYTICS_SUCCESS: 'GET_PAGE_ANALYTICS_SUCCESS',
  GET_PAGE_ANALYTICS_FAILURE: 'GET_PAGE_ANALYTICS_FAILURE',
};

export default types;
